import { render, staticRenderFns } from "./coupon-rule-modal.vue?vue&type=template&id=6a177054&"
import script from "./coupon-rule-modal.vue?vue&type=script&lang=js&"
export * from "./coupon-rule-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports